{
  "title": "Ойын лоббиі",
  "subtitle": "Aggregator каталогындағы барлық ойындар осында қолжетімді.",
  "searchPlaceholder": "Ойын іздеу",
  "categories": "Санаттар",
  "all": "Барлығы",
  "slots": "Слоттар",
  "live": "Тікелей казино",
  "crash": "Crash",
  "instant": "Instant",
  "table": "Үстел",
  "other": "Басқа",
  "popular": "Танымал",
  "new": "Жаңа",
  "jackpot": "Джекпот",
  "tags": "Сүзгілер",
  "providers": "Провайдерлер",
  "emptyTitle": "Ойындар әзірге қолжетімсіз",
  "emptyBody": "Провайдер каталогы синхрондалмаған. Нақты немесе демо ойындар тек расталған интеграциядан кейін қосылады.",
  "errorTitle": "Каталог жүктелмеді",
  "errorBody": "Ойын тізімін алу кезінде қате шықты. Кейінірек қайта көріңіз.",
  "notPlayable": "Қазір ашылмайды",
  "demoUnavailable": "Демо әлі белсенді емес",
  "realMoneyDisabled": "Нақты ақшалы ойындар өшірулі",
  "provider": "Провайдер",
  "results": "{{count}} ойын",
  "featured": "Таңдаулы",
  "lobbySection": "Каталог",
  "allProviders": "Барлық провайдерлер",
  "sort": "Сұрыптау",
  "sortRecommended": "Ұсынылған",
  "sortName": "Атауы",
  "sortProvider": "Провайдер",
  "favorite": "Таңдаулы",
  "selectWallet": "Ойын алдында балансты таңдаңыз",
  "realBalance": "Негізгі баланс",
  "bonusBalance": "Бонус баланс",
  "fundingLocked": "Таңдалған баланс бүкіл ойын сессиясында сақталады. Нақты және бонус қаражаты араласпайды.",
  "launchPlay": "Ойнау",
  "bonusNotSlot": "Бонусты тек расталған слоттарда пайдалануға болады",
  "bonusPlayDisabled": "Бонус ойын әлі белсенді емес",
  "sessionFundingUnsupported": "Провайдер сессияның қаржы көзін қауіпсіз сақтай алмады. Бұл режим бұғатталды.",
  "loginToPlay": "Ойнау үшін кіріңіз",
  "sessionLaunched": "Ойын сессиясы жасалды",
  "loadMore": "Тағы көрсету",
  "loadingMore": "Жүктелуде…",
  "showingOf": "{{shown}} / {{total}} ойын",
  "launchDemo": "ДЕМО ОЙНАУ",
  "launchReal": "НАҚТЫ БАЛАНСПЕН ОЙНАУ",
  "launchBonus": "БОНУС БАЛАНСПЕН ОЙНАУ",
  "demoLaunched": "Демо сессия жасалды",
  "history": "Ойын тарихы",
  "searchResults": "Іздеу",
  "bonusContinueTitle": "Бонуспен жалғастыру?",
  "bonusContinueBody": "Негізгі баланс 0. Бонус бар — тек сіз таңдасаңыз.",
  "openExternal": "Ойынды ашу",
  "openExternalHint": "Ойын іште ашылмаса, төмендегі батырманы басыңыз.",
  "backToCatalog": "Каталогқа оралу",
  "notFound": "Ойын табылмады",
  "recommended": "Ұсынылатындар",
  "fastGames": "Жылдам ойындар",
  "bonusWager": "Бонуспен ставка"
}
